import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Swal from "sweetalert2";

import AuthLayout from "./auth/AuthLayout";
import PageTitleUpdater from "./auth/PageTitleUpdater";

import Login from "./auth/Login";
import SendEmail from "./auth/SendEmail";
import VerifyEmail from "./auth/VerifyEmail";
import ResetPassword from "./auth/ResetPassword";
import SuccessfulReset from "./auth/Successful";

// Styles
import "./css/Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ComingSoon from "./auth/ComingSoon";

import PredictUsecase from "./ai/predictUseCases.jsx";
import RainfallPredict from "./ai/RainfallPredict.jsx";
import WeatherPredict from "./ai/WeatherPredict.jsx";
import HousePredict from "./ai/HousePredict.jsx";

import "./App.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Enterprise from "./pages/EnterPrise";
import ActivityLog from "./pages/ActivityLog";
import RoleManagement from "./pages/RoleManagement";
import ModuleManagement from "./superadmin/ModuleMangement";
import UserManagement from "./superadmin/UserManagement";

import SuperAdminLayout from "./superadmin/SuperAdminLayout";
import ProductManagement from "./superadmin/ProductManagement";

import NotFoundPage from "./pages/NotFoundPage";
import Desktop from "./pages/Desktop";
import Topbar from "./pages/Topbar";
import PinHolePrediction from "./ai/pinHoleDetection";
import AccidentPrediction from "./ai/accidentDetection.js";
import ChurnPredictionPage from "./ai/ChurnPredictionPage.js";
import FraudDetectionSystem from "./ai/FraudDetectionSystem.jsx";
import SpecificTransaction from "./components/SpecificTransaction.jsx";
import MultipleTransaction from "./components/MultipleTransaction.jsx";
import FinancialAdvisoryTool from "./ai/FinancialAdvisoryTool.jsx";
import DeliveryETA from "./ai/DeliveryETA.jsx";

const AppRoutes = () => {
  const [activeTab, setActiveTab] = useState("All"); // All is default
  const [selectedFilter, setSelectedFilter] = useState(null); // null = no filter initially

  return (
    <>
      <PageTitleUpdater />
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<SendEmail />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/successful" element={<SuccessfulReset />} />
        </Route>

        <Route path="/superadmin" element={<SuperAdminLayout />}>
          <Route path="enterprise-management" element={<Enterprise />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="role-management" element={<RoleManagement />} />
          <Route path="product-management" element={<ProductManagement />} />
          <Route path="module" element={<ModuleManagement />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="*" element={<ComingSoon />} />
        </Route>

        <Route
          path="/user/*"
          element={
            <>
              <Topbar
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
              />
              <Routes>
                <Route
                  path="dashboard"
                  element={
                    <Desktop
                      activeTab={activeTab}
                      selectedFilter={selectedFilter}
                    />
                  }
                />
                <Route
                  path="dashboard/financial_advisory"
                  element={<FinancialAdvisoryTool />}
                />
                <Route
                  path="dashboard/prediction-page"
                  element={<PredictUsecase />}
                />
                <Route
                  path="dashboard/pothole_detection"
                  element={<PinHolePrediction />}
                />
                <Route
                  path="dashboard/accident_detection"
                  element={<AccidentPrediction />}
                />
                <Route
                  path="dashboard/house_predict"
                  element={<HousePredict />}
                />
                <Route
                  path="dashboard/rainfall_predict"
                  element={<RainfallPredict />}
                />
                <Route
                  path="dashboard/weather_predict"
                  element={<WeatherPredict />}
                />
                <Route
                  path="dashboard/fraud_detection"
                  element={<FraudDetectionSystem />}
                />
                <Route
                  path="dashboard/fraud_detection/specific_transaction"
                  element={<SpecificTransaction />}
                />
                <Route
                  path="dashboard/fraud_detection/multiple_transaction"
                  element={<MultipleTransaction />}
                />
                <Route
                  path="dashboard/delivery-eta"
                  element={<DeliveryETA />}
                />
                <Route
                  path="dashboard/churn_prediction"
                  element={<ChurnPredictionPage />}
                />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </>
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        closeButton={false}
        hideProgressBar={false}
        newestOnTop={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        limit={1}
      />
    </Router>
  );
};

export default App;
